export default [
  {
    path: "/register",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/register",
        name: "register",
        component: () => import("./Register.vue"),
      }
    ],
  }
];
